var onlinetransaction_table_pay, onlinetransaction_table_report, onlinetransaction_table_apply, onlinetransaction_table_book;
jQuery(function ($) {
  //apply
  onlinetransaction_table_apply = $('#online-transaction-data-Apply').DataTable({
    layout: {
      top3Start: {
        search: {
          placeholder: 'Search Apply'
        }
      },
      top2Start: {
        div: {
          html: '<div class="col-auto col-md-3-1 online-search-box-sort filterby table-search-field nopaddinglr d-block d-lg-none"></div><div class="col-12 col-md-6 online-search-box-sort filterby table-search-field nopaddinglr d-none d-lg-block"></div>'
        }
      },
      top2End: 'pageLength',
      top: null,
      topStart: 'info',
      topEnd: null,
      bottom: {
        paging: {
          type: 'simple_numbers'
        }
      },
      bottomStart: null,
      bottomEnd: null
    },
    // "dom": '<"top row nopadding"<"col-12 table-searchbox-field"f><"col-12 nopaddinglr online-transaction-cat"><"col-auto col-md-3-1 online-search-box-sort filterby table-search-field nopaddinglr d-block d-lg-none"l><"col-12 col-md-6 online-search-box-sort table-search-field filterby nopaddinglr d-none d-lg-block"l><"col-auto col-md-3-1 table-search-field sortby nopaddinglr d-block d-lg-none"l><"col-12 col-md-6 table-search-field sortby nopaddinglr d-none d-lg-block"l><"col-12 table-search-field nopaddinglr"i><"col-12 table-data nopadding-onlinetransaction"rt><"bottom col-12 col-lg-12 nopadding"p><"clearboth">',
    "language": {
      "search": "",
      "infoFiltered": "",
      "info": "Showing _START_ to _END_ of _TOTAL_",
      "infoEmpty": "Showing 0 to 0 of 0",
      "lengthMenu": "Show _MENU_",
      "zeroRecords": "<span>No results found for <strong>[searchValue]</strong></span><ul><li>Check the spelling.</li><li>Try using different words.</li><li>Try a more concise search.</li></ul>",
      "paginate": {
        "previous": 'Previous',
        "next": 'Next'
      }
    },
    "columnDefs": [{
      "targets": [1, 2],
      "visible": false
    }],
    "lengthMenu": [[-1, 10, 25, 50, 100], ['All', 10, 25, 50, 100]],
    "infoCallback": function (settings, start, end, max, total, pre) {
      if (this.api().page.info().pages > 1) {
        $('#online-transaction-data-Apply_wrapper .dt-paging').show();
      } else {
        $('#online-transaction-data-Apply_wrapper .dt-paging').hide();
      }
      return "Showing " + start + " to " + end + " of " + total;
    }, 
    order: [[2, 'asc']]

  }); 
  //pay
    onlinetransaction_table_pay = $('#online-transaction-data-Pay').DataTable({
        layout: {
          top3Start: {
            search: {
              placeholder: 'Search Pay'
            }
          },
          top2Start: {
            div: {
              html: '<div class="col-auto col-md-3-1 online-search-box-sort filterby table-search-field nopaddinglr d-block d-lg-none"></div><div class="col-12 col-md-6 online-search-box-sort filterby table-search-field nopaddinglr d-none d-lg-block"></div>'
            }
          },
          top2End: 'pageLength',
          top: null,
          topStart: 'info',
          topEnd: null,
          bottom: {
            paging: {
              type: 'simple_numbers'
            }
          },
          bottomStart: null,
          bottomEnd: null
        },
        // "dom": '<"top row nopadding"<"col-12 table-searchbox-field"f><"col-12 nopaddinglr online-transaction-cat"><"col-auto col-md-3-1 online-search-box-sort filterby table-search-field filterby nopaddinglr d-block d-lg-none"l><"col-12 col-md-6 online-search-box-sort table-search-field filterby nopaddinglr d-none d-lg-block"l><"col-auto col-md-3-1 table-search-field sortby nopaddinglr d-block d-lg-none"l><"col-12 col-md-6 table-search-field sortby nopaddinglr d-none d-lg-block"l><"col-12 table-search-field nopaddinglr"i><"col-12 table-data nopadding-onlinetransaction"rt><"bottom col-12 col-lg-12 nopadding"p><"clearboth">',
        "language": {
        "search": "",
        "infoFiltered": "",
        "info": "Showing _START_ to _END_ of _TOTAL_",
        "infoEmpty": "Showing 0 to 0 of 0",
        "lengthMenu": "Show _MENU_",
        "zeroRecords": "<span>No results found for <strong>[searchValue]</strong></span><ul><li>Check the spelling.</li><li>Try using different words.</li><li>Try a more concise search.</li></ul>",
        "paginate": {
          "previous": 'Previous',
          "next": 'Next'
        }
      },
      "columnDefs": [{
        "targets": [1, 2],
        "visible": false
      }],
      "lengthMenu": [[-1, 10, 25, 50, 100], ['All', 10, 25, 50, 100]],
      "infoCallback": function (settings, start, end, max, total, pre) {
        if (this.api().page.info().pages > 1) {
          $('#online-transaction-data-Pay_wrapper .dt-paging').show();
        } else {
          $('#online-transaction-data-Pay_wrapper .dt-paging').hide();
        }
        return "Showing " + start + " to " + end + " of " + total;
      }, 
      order: [[2, 'asc']]
    }); 
    //report
    onlinetransaction_table_report = $('#online-transaction-data-Report').DataTable({
      layout: {
        top3Start: {
          search: {
            placeholder: 'Search Report'
          }
        },
        top2Start: {
          div: {
            html: '<div class="col-auto col-md-3-1 online-search-box-sort filterby table-search-field nopaddinglr d-block d-lg-none"></div><div class="col-12 col-md-6 online-search-box-sort filterby table-search-field nopaddinglr d-none d-lg-block"></div>'
          }
        },
        top2End: 'pageLength',
        top: null,
        topStart: 'info',
        topEnd: null,
        bottom: {
          paging: {
            type: 'simple_numbers'
          }
        },
        bottomStart: null,
        bottomEnd: null
      },
      // "dom": '<"top row nopadding"<"col-12 table-searchbox-field"f><"col-12 nopaddinglr online-transaction-cat"><"col-auto col-md-3-1 online-search-box-sort filterby table-search-field nopaddinglr d-block d-lg-none"l><"col-12 col-md-6 online-search-box-sort filterby table-search-field nopaddinglr d-none d-lg-block"l><"col-auto col-md-3-1 table-search-field sortby nopaddinglr d-block d-lg-none"l><"col-12 col-md-6 table-search-field sortby nopaddinglr d-none d-lg-block"l><"col-12 table-search-field nopaddinglr"i><"col-12 table-data nopadding-onlinetransaction"rt><"bottom col-12 col-lg-12 nopadding"p><"clearboth">',
      "language": {
        "search": "",
        "infoFiltered": "",
        "info": "Showing _START_ to _END_ of _TOTAL_",
        "infoEmpty": "Showing 0 to 0 of 0",
        "lengthMenu": "Show _MENU_",
        "zeroRecords": "<span>No results found for <strong>[searchValue]</strong></span><ul><li>Check the spelling.</li><li>Try using different words.</li><li>Try a more concise search.</li></ul>",
        "paginate": {
          "previous": 'Previous',
          "next": 'Next'
        }
      },
      "columnDefs": [{
        "targets": [1, 2],
        "visible": false
      }],
      "lengthMenu": [[-1, 10, 25, 50, 100], ['All', 10, 25, 50, 100]],
      "infoCallback": function (settings, start, end, max, total, pre) {
        if (this.api().page.info().pages > 1) {
          $('#online-transaction-data-Report_wrapper .dt-paging').show();
        } else {
          $('#online-transaction-data-Report_wrapper .dt-paging').hide();
        }
        return "Showing " + start + " to " + end + " of " + total;
      }, 
      order: [[2, 'asc']]
    });
  //book
  onlinetransaction_table_book = $('#online-transaction-data-Book').DataTable({
    layout: {
      top3Start: {
        search: {
          placeholder: 'Search Book'
        }
      },
      top2Start: {
        div: {
          html: '<div class="col-auto col-md-3-1 online-search-box-sort filterby table-search-field nopaddinglr d-block d-lg-none"></div><div class="col-12 col-md-6 online-search-box-sort filterby table-search-field nopaddinglr d-none d-lg-block"></div>'
        }
      },
      top2End: 'pageLength',
      top: null,
      topStart: 'info',
      topEnd: null,
      bottom: {
        paging: {
          type: 'simple_numbers'
        }
      },
      bottomStart: null,
      bottomEnd: null
    },
    // "dom": '<"top row nopadding"<"col-12 table-searchbox-field"f><"col-12 nopaddinglr online-transaction-cat"><"col-auto col-md-3-1 online-search-box-sort filterby table-search-field nopaddinglr d-block d-lg-none"l><"col-12 col-md-6 online-search-box-sort filterby table-search-field nopaddinglr d-none d-lg-block"l><"col-auto col-md-3-1 table-search-field sortby nopaddinglr d-block d-lg-none"l><"col-12 col-md-6 table-search-field sortby nopaddinglr d-none d-lg-block"l><"col-12 table-search-field nopaddinglr"i><"col-12 table-data nopadding-onlinetransaction"rt><"bottom col-12 col-lg-12 nopadding"p><"clearboth">',
    "language": {
        "search": "",
        "infoFiltered": "",
        "info": "Showing _START_ to _END_ of _TOTAL_",
        "infoEmpty": "Showing 0 to 0 of 0",
        "lengthMenu": "Show _MENU_",
        "zeroRecords": "<span>No results found for <strong>[searchValue]</strong></span><ul><li>Check the spelling.</li><li>Try using different words.</li><li>Try a more concise search.</li></ul>",
        "paginate": {
          "previous": 'Previous',
          "next": 'Next'
        }
      },
      "columnDefs": [{
        "targets": [1, 2],
        "visible": false
      }],
      "lengthMenu": [[-1, 10, 25, 50, 100], ['All', 10, 25, 50, 100]],
      "infoCallback": function (settings, start, end, max, total, pre) {
        if (this.api().page.info().pages > 1) {
          $('#online-transaction-data-Book_wrapper .dt-paging').show();
        } else {
          $('#online-transaction-data-Book_wrapper .dt-paging').hide();
        }
        return "Showing " + start + " to " + end + " of " + total;
      }, 
      order: [[2, 'asc']]
    }); 
    $('#online-transaction-data-Apply_wrapper .online-search-box-sort').html('<div id="online-transaction-most_popular"><div class="WidthLabel100">Sort by </div><div class="WidthElement100"><select name="TableSortApply" class="TableSort"><option value="mp">Most popular</option><option value="asc">A to Z</option><option value="desc">Z to A</option></select></div></div>');
    $('#online-transaction-data-Book_wrapper .online-search-box-sort').html('<div id="online-transaction-most_popular"><div class="WidthLabel100">Sort by </div><div class="WidthElement100"><select name="TableSortBook" class="TableSort"><option value="mp">Most popular</option><option value="asc">A to Z</option><option value="desc">Z to A</option></select></div></div>');
    $('#online-transaction-data-Pay_wrapper .online-search-box-sort').html('<div id="online-transaction-most_popular"><div class="WidthLabel100">Sort by </div><div class="WidthElement100"><select name="TableSortPay" class="TableSort"><option value="mp">Most popular</option><option value="asc">A to Z</option><option value="desc">Z to A</option></select></div></div>');
    $('#online-transaction-data-Report_wrapper .online-search-box-sort').html('<div id="online-transaction-most_popular"><div class="WidthLabel100">Sort by </div><div class="WidthElement100"><select name="TableSortReport" class="TableSort"><option value="mp">Most popular</option><option value="asc">A to Z</option><option value="desc">Z to A</option></select></div></div>');
    $('.TableSort[name=TableSortApply]').on('click', function (e) {
      switch ($(this).val()) {
          case "mp": // first option chosen, not associated with any column, do some default
              $('#online-transaction-data-Apply').DataTable().order([2, 'asc']).draw();
              break;
          case "asc":
              $('#online-transaction-data-Apply').DataTable().order([0, 'asc']).draw();
              break;
          case "desc":
            $('#online-transaction-data-Apply').DataTable().order([0, 'desc']).draw();
              break;
      }
    });
    $('.TableSort[name=TableSortBook]').on('click', function (e) {
      switch ($(this).val()) {
          case "mp": // first option chosen, not associated with any column, do some default
              $('#online-transaction-data-Book').DataTable().order([2, 'asc']).draw();
              break;
          case "asc":
              $('#online-transaction-data-Book').DataTable().order([0, 'asc']).draw();
              break;
          case "desc":
            $('#online-transaction-data-Book').DataTable().order([0, 'desc']).draw();
              break;
      }
    });
    $('.TableSort[name=TableSortPay]').on('click', function (e) {
      switch ($(this).val()) {
          case "mp": // first option chosen, not associated with any column, do some default
              $('#online-transaction-data-Pay').DataTable().order([2, 'asc']).draw();
              break;
          case "asc":
              $('#online-transaction-data-Pay').DataTable().order([0, 'asc']).draw();
              break;
          case "desc":
            $('#online-transaction-data-Pay').DataTable().order([0, 'desc']).draw();
              break;
      }
    });
    $('.TableSort[name=TableSortReport]').on('click', function (e) {
      switch ($(this).val()) {
          case "mp": // first option chosen, not associated with any column, do some default
              $('#online-transaction-data-Report').DataTable().order([2, 'asc']).draw();
              break;
          case "asc":
              $('#online-transaction-data-Report').DataTable().order([0, 'asc']).draw();
              break;
          case "desc":
            $('#online-transaction-data-Report').DataTable().order([0, 'desc']).draw();
              break;
      }
    });
    $('#online-transaction-data-Pay_wrapper input').on('input', function () {
        var searchInput =  $('#online-transaction-data-Pay_wrapper input').val();
        if(searchInput!=''){
            document.getElementById('btnClrSearchPay').style.display = "inline";
        }else{
            document.getElementById('btnClrSearchPay').style.display = "none";
        }
        setEmptyMessage($('#online-transaction-data-Pay_wrapper input').val());
    });
    $('#online-transaction-data-Apply_wrapper input').on('input', function () {
      var searchInput =  $('#online-transaction-data-Apply_wrapper input').val();
      if(searchInput!=''){
          document.getElementById('btnClrSearchApply').style.display = "inline";
      }else{
          document.getElementById('btnClrSearchApply').style.display = "none";
      }
      setEmptyMessage($('#online-transaction-data-Apply_wrapper input').val());
    });
    $('#online-transaction-data-Book_wrapper input').on('input', function () {
      var searchInput =  $('#online-transaction-data-Book_wrapper input').val();
      if(searchInput!=''){
          document.getElementById('btnClrSearchBook').style.display = "inline";
      }else{
          document.getElementById('btnClrSearchBook').style.display = "none";
      }
      setEmptyMessage($('#online-transaction-data-Book_wrapper input').val());
    });
    $('#online-transaction-data-Report_wrapper input').on('input', function () {
      var searchInput =  $('#online-transaction-data-Report_wrapper input').val();
      if(searchInput!=''){
          document.getElementById('btnClrSearchReport').style.display = "inline";
      }else{
          document.getElementById('btnClrSearchReport').style.display = "none";
      }
      setEmptyMessage($('#online-transaction-data-Report_wrapper input').val());
    });
}); 
$(function(){
  $('button[role="tab"]').on("click", function(e) {
    const hash = $(this).attr("id").split('-')[0];
    var uri = window.location.toString();
    var clean_uri = uri.split('#')[0];
    window.location.href= clean_uri + "#" + hash;
  });
  if($('.quicklinks-Pay').html().indexOf('href') > -1){
    $("<div class='quicklinks pe-3'>"+$('.quicklinks-Pay').html()+"</div>").insertAfter($("#online-transaction-data-Pay_wrapper > div:nth-child(1)"));
  }else{
    $('#online-transaction-data-Pay_wrapper > div:nth-child(1)').css({'border-bottom-left-radius': '24px', 'border-bottom-right-radius': '24px'});
  }
  if($('.quicklinks-Report').html().indexOf('href') > -1){
    $("<div class='quicklinks pe-3'>"+$('.quicklinks-Report').html()+"</div>").insertAfter($("#online-transaction-data-Report_wrapper > div:nth-child(1)"));
  }else{
    $('#online-transaction-data-Report_wrapper > div:nth-child(1)').css({'border-bottom-left-radius': '24px', 'border-bottom-right-radius': '24px'});
  }
  if($('.quicklinks-Apply').html().indexOf('href') > -1){
    $("<div class='quicklinks pe-3'>"+$('.quicklinks-Apply').html()+"</div>").insertAfter($("#online-transaction-data-Apply_wrapper > div:nth-child(1)"));
  }else{
    $("#online-transaction-data-Apply_wrapper > div:nth-child(1)").css({'border-bottom-left-radius': '24px', 'border-bottom-right-radius': '24px'});
  }
  if($('.quicklinks-Book').html().indexOf('href') > -1){
    $("<div class='quicklinks pe-3'>"+$('.quicklinks-Book').html()+"</div>").insertAfter($("#online-transaction-data-Book_wrapper > div:nth-child(1)"));
  }else{
    $('#online-transaction-data-Book_wrapper > div:nth-child(1)').css({'border-bottom-left-radius': '24px', 'border-bottom-right-radius': '24px'});
  }
  $('.dt-search').addClass('input-group');
  $('<button id="btnClrSearchPay" class="btnCloseCurveSearch searchButtonCurve" onclick="javascript:clearSearchPay();"><i class="fa-light fa-xmark" aria-hidden="true"></i></button><button type="submit" class="btnSubmitCurveSearch searchButtonCurve"><i class="fal fa-lg fa-search" aria-hidden="true"></i></button>').insertAfter($('#online-transaction-data-Pay_wrapper .dt-search label'));
  $('<button id="btnClrSearchReport" class="btnCloseCurveSearch searchButtonCurve" onclick="javascript:clearSearchReport();"><i class="fa-light fa-xmark" aria-hidden="true"></i></button><button type="submit" class="btnSubmitCurveSearch searchButtonCurve"><i class="fal fa-lg fa-search" aria-hidden="true"></i></button>').insertAfter($('#online-transaction-data-Report_wrapper .dt-search label'));
  $('<button id="btnClrSearchBook" class="btnCloseCurveSearch searchButtonCurve" onclick="javascript:clearSearchBook();"><i class="fa-light fa-xmark" aria-hidden="true"></i></button><button type="submit" class="btnSubmitCurveSearch searchButtonCurve"><i class="fal fa-lg fa-search" aria-hidden="true"></i></button>').insertAfter($('#online-transaction-data-Book_wrapper .dt-search label'));
  $('<button id="btnClrSearchApply" class="btnCloseCurveSearch searchButtonCurve" onclick="javascript:clearSearchApply();"><i class="fa-light fa-xmark" aria-hidden="true"></i></button><button type="submit" class="btnSubmitCurveSearch searchButtonCurve"><i class="fal fa-lg fa-search" aria-hidden="true"></i></button>').insertAfter($('#online-transaction-data-Apply_wrapper .dt-search label'));
  $('#online-transaction-data-Apply').attr("role","presentation");
  $('#online-transaction-data-Book').attr("role","presentation");
  $('#online-transaction-data-Pay').attr("role","presentation");
  $('#online-transaction-data-Report').attr("role","presentation");
});
function clearSearchPay() {
    onlinetransaction_table_pay
    .search('')
    .draw();
    document.getElementById('btnClrSearchPay').style.display = "none";
};  
function clearSearchReport() {
    onlinetransaction_table_report
    .search('')
    .draw();
    document.getElementById('btnClrSearchReport').style.display = "none";
};  
function clearSearchApply() {
  onlinetransaction_table_apply
  .search('')
  .draw();
  document.getElementById('btnClrSearchApply').style.display = "none";
};  
function clearSearchBook() {
  onlinetransaction_table_book
  .search('')
  .draw();
  document.getElementById('btnClrSearchBook').style.display = "none";
};  
function setEmptyMessage(str){
    if($('.dt-empty').length) {
      $('.dt-empty > span > strong').text(str);
    }
}
function filterPay(str) {
    if(str == 'Roads'){
        str = 'Road';
    }else{
        if(str == 'Dogs'){
            str = 'Dog';
        }
    }
    onlinetransaction_table_pay
    .search(str)
    .draw();
    if(str!=''){
        document.getElementById('btnClrSearchPay').style.display = "inline";
        setEmptyMessage(str);
    }else{
        document.getElementById('btnClrSearchPay').style.display = "none";
    }
};     
function filterBook(str) {
  if(str == 'Roads'){
      str = 'Road';
  }else{
      if(str == 'Dogs'){
          str = 'Dog';
      }
  }
  onlinetransaction_table_book
  .search(str)
  .draw();
  if(str!=''){
      document.getElementById('btnClrSearchBook').style.display = "inline";
      setEmptyMessage(str);
  }else{
      document.getElementById('btnClrSearchBook').style.display = "none";
  }
};    
function filterApply(str) {
  if(str == 'Roads'){
      str = 'Road';
  }else{
      if(str == 'Dogs'){
          str = 'Dog';
      }
  }
  onlinetransaction_table_apply
  .search(str)
  .draw();
  if(str!=''){
      document.getElementById('btnClrSearchApply').style.display = "inline";
      setEmptyMessage(str);
  }else{
      document.getElementById('btnClrSearchApply').style.display = "none";
  }
};    
function filterReport(str) {
  if(str == 'Roads'){
      str = 'Road';
  }else{
      if(str == 'Dogs'){
          str = 'Dog';
      }
  }
  onlinetransaction_table_report
  .search(str)
  .draw();
  if(str!=''){
      document.getElementById('btnClrSearchReport').style.display = "inline";
      setEmptyMessage(str);
  }else{
      document.getElementById('btnClrSearchReport').style.display = "none";
  }
};    

$(window).on("load", function () {
      selectTab();
      if($('#online-transaction-data-Pay_wrapper input').val()!=''){
          filterPay($('#online-transaction-data-Pay_wrapper input').val());
      }else{
          document.getElementById('btnClrSearchPay').style.display = "none";
      }
      if($('#online-transaction-data-Book_wrapper input').val()!=''){
        filterBook($('#online-transaction-data-Book_wrapper input').val());
      }else{
          document.getElementById('btnClrSearchBook').style.display = "none";
      }
      if($('#online-transaction-data-Apply_wrapper input').val()!=''){
        filterApply($('#online-transaction-data-Apply_wrapper input').val());
      }else{
          document.getElementById('btnClrSearchApply').style.display = "none";
      }
      if($('#online-transaction-data-Report_wrapper input').val()!=''){
        filterReport($('#online-transaction-data-Report_wrapper input').val());
      }else{
          document.getElementById('btnClrSearchReport').style.display = "none";
      }
}); 
function selectTab(){
  var url = window.location.href;
  var activeTab = '';
  if (url.indexOf("#") > 0){
    activeTab = url.substring(url.indexOf("#") + 1);
  }else{
    activeTab = (window.location.href.split("/").filter(e => e).pop())[0].toUpperCase()+
    (window.location.href.split("/").filter(e => e).pop()).slice(1);
  }
  if(activeTab == 'Do-it-online'){
    activeTab = 'Apply';
  }
  $('.nav[role="tablist"] button[id="'+activeTab+'-tab"]').tab('show');
}
function filterByKeyword(type, keyword){
  switch (type) {
    case 'Pay':
      filterPay(keyword);
      break;
    case 'Book':
      filterBook(keyword);
      break;
    case 'Apply':
      filterApply(keyword);
      break;
    case 'Report':
      filterReport(keyword);
      break;
  }
}
